export const hero = {
  title : "bookeeping_title",
  description : "bookeeping_description",
  button : [
    {
      text:"home_pricing",
      link: "#pricing"
    },
    {
      text:"pricing_button_text",
      link: "#gratis"
    },
  ]
}